// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kn-0";
export var fileCarousel = "_kn-2";
export var removeFileButton = "_kn-1";